import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { PageViewComponent } from '../../page-view/page-view.component';

@Component({
  selector: 'app-training-management',
  templateUrl: './training-management.component.html',
  styleUrls: ['./training-management.component.scss']
})

export class TrainingManagementComponent extends PageViewComponent implements OnInit {
  static cdrStatic;
  static activeTrainingPage = -1;
  headers: Array<string>;
  @ViewChild('scrollPage') private scrollContainer: ElementRef;

  @Input() adminClientId: string;

  constructor(ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.headers = this.stringTableService.getArrayOfStrings('training-management', 'unit-headers');
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.navigated = false;
    this.router.events.subscribe((evt) => {
      if (evt) {
        this.router.navigated = false;
      }
    });
    TrainingManagementComponent.cdrStatic = this.cdr;
  }

  static setActiveTrainingPage(activePage) {
    TrainingManagementComponent.activeTrainingPage = activePage;
    TrainingManagementComponent.cdrStatic.detectChanges();
  }

  ngOnInit() { }

  changeActiveTrainingPage(event) {
    const selectedNavIndex = event.index;
    switch (selectedNavIndex) {
      case 0:
        this.router.navigate(['home']);
        break;
      case 1:
        this.router.navigate(['create-autotraining']);
        break;
      case 2:
        this.router.navigate(['inactive-autotraining']);
        break;
      case 3:
        this.router.navigate(['email-invite']);
        break;
      case 4:
        this.router.navigate(['email-sent']);
        break;
      case 5:
        this.router.navigate(['reporting']);
        break;
      case 6:
        this.router.navigate(['super-admin']);
        break;
    
      default:
        break;
    }
  }

  onTabChanged(event) {
    this.scrollContainer.nativeElement.scrollTop = 0;
  }

  get getActivePage() {
    return TrainingManagementComponent.activeTrainingPage;
  }
}

export enum activeTrainingPageEnum {
  trainingManagementHome = -1,
  createAutoTrainingCode = 2,
  inactiveAutoTrainingCode = 3,
  emailInvite = 4,
  emailSent = 5,
  reporting = 6,
  superAdmin = 7,
  origin = 8
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/training-management/training-management.component.ts